import React from "react";
import {Table, TableBody, TableCell, TableContainer, TableRow} from "@mui/material";
import type {ColSpec} from "../../../components/table/MithraTableHeadColumns";
import {MithraTableHeadColumns} from "../../../components/table/MithraTableHeadColumns";

type Props = {
    values: string[],
}
export const FlexibleTable: React.FC<Props> = ({values}) => {
    if (values.length === 0) return <></>;
    const value_objs: any[] = values.map(val => {
        const obj = {unknown: ''};
        val.split(',').forEach(kv => {
            if (kv.trim().split(':').length === 2) {
                obj[kv.trim().split(':')[0].trim().replace('_', ' ').replace('-', ' ')
                    ] = kv.trim().split(':')[1].trim();
            } else {
                obj['unknown'] += kv;
            }
        });
        return obj;
    });
    const obj_cols = Object.keys(value_objs[0]).filter(k => k !== 'unknown' && value_objs.slice(1).every(obj => obj[k] !== undefined)).map(col => ({
        txt: col,
        cls: ''
    } as ColSpec));
    return <TableContainer className="flexible-table">
        <Table cellPadding={1}>
            <MithraTableHeadColumns columns={[{txt: '#', cls: ''}, ...obj_cols, {txt: 'Other info', cls: ''}]}/>
            <TableBody>
                {value_objs.map((obj, idx) => <TableRow key={idx}>
                    <TableCell>{idx + 1}</TableCell>
                    {obj_cols.map((col, idx2) => <TableCell key={idx2}>
                        {obj[col.txt]}
                    </TableCell>)}
                    <TableCell>
                        {Object.keys(obj).filter(key => obj_cols.map(col => col.txt).indexOf(key) === -1).map(key => obj[key]).join("\n")}
                    </TableCell>
                </TableRow>)}
            </TableBody>
        </Table>
    </TableContainer>
}